import { render, staticRenderFns } from "./LifeInsuranceAllInTrustYN.vue?vue&type=template&id=6933367c"
import script from "./LifeInsuranceAllInTrustYN.vue?vue&type=script&lang=js"
export * from "./LifeInsuranceAllInTrustYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports